import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import UserExperienceImg from "../../images/user-experience.svg"
import EssentialsPageStyle from "./essentials-page.module.scss"

const UserExperience = () => (
    <StaticQuery query={graphql`
        query UserExperience{
            contentfulTheEssentialsPage{
                essentialsReference{
                  sectionContent1{
                    subtitle{
                      subtitle
                    }
                    sectionParagraph{
                      json
                    }
                  }
                }
              }
            }
        `}
    render={data =>(
    <div className={EssentialsPageStyle.sectionDiv}>

        {/* Features Links */}
        <Row className={EssentialsPageStyle.section1Features} id="parent-div">
            <Col xs={12}><h3 className={EssentialsPageStyle.sectionTitle}>Website Features</h3></Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EssentialsPageStyle.featuresBtn1} to="/essentials">The Essentials</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EssentialsPageStyle.featuresBtn2} to="/mobile-first">Mobile First</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EssentialsPageStyle.featuresBtn3} to="/engaging-menu">Engaging Menu</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                 <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={EssentialsPageStyle.featuresBtn4} to="/convenient-booking">Convenient Booking</Link>
                </ScrollAnimation>
                </div>
            </Col>
        </Row>
        
        <Row className={EssentialsPageStyle.userExperienceDiv}>
            <Col className={EssentialsPageStyle.userExperienceCol1} sm={6}>
                <h3 className={EssentialsPageStyle.sectionTitleLeftAlign}>{data.contentfulTheEssentialsPage.essentialsReference.sectionContent1.subtitle.subtitle}</h3>
                <div className={EssentialsPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulTheEssentialsPage.essentialsReference.sectionContent1.sectionParagraph.json)}  
                </div>
            </Col>
            <Col sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <UserExperienceImg className={EssentialsPageStyle.userExperienceImg} />
                </ScrollAnimation>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default UserExperience